module.exports = __webpack_public_path__ + "static/media/white-freehand-polygon-measure-icon.765de7bc.svg";